import React, { useEffect, useState } from 'react'
import {
    Skeleton,
    Typography,
    Box,
    Stack,
    TableContainer,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@mui/material'

import { PatientNodeProp, PatientLog } from '../../utils/types'
import { get } from '../../utils/http'

interface Props {
    patient: PatientNodeProp
}

const PatientLogs = ({ patient }: Props) => {
    const [logData, setLogData] = useState<PatientLog[]>([])
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    const getLogs = async () => {
        try {
            const res = await get(`PatientLogs/patient/${patient.name}`)
            if (res.length) setLogData(res)
            else throw Error('NF')
        } catch (err) {
            setLogData([{ id: 0, patient_id: 0, patient_str_id: 'NF', datetime: 'NF', action_taken: 'NF' }])
        }
    }

    useEffect(() => {
        getLogs()
    }, [patient]) // eslint-disable-line

    return (
        <Box className='d-flex flex-column gap-4'>
            <Typography variant="h5" component="h1">Logs</Typography>
            <Box className='d-flex flex-column gap-2'>
                <Typography>{patient.name}</Typography>
                {logData.length
                    ? <TableContainer component={Paper}>
                        <Table size="small" aria-label="user table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap'>Time (UTC)</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Message</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {logData.map((item) => {
                                    const date = new Date(item.datetime)
                                    const hour = date.getHours() > 12 ? date.getHours() - 12 : date.getHours()
                                    return (
                                        <TableRow key={item.id}>
                                            <TableCell className='text-nowrap'>
                                                {hour === 0 ? 12 : hour}:{date.getMinutes() <= 9 ? `0${date.getMinutes()}` : date.getMinutes()} {date.getHours() >= 12 ? 'PM' : 'AM'}
                                            </TableCell>
                                            <TableCell className='text-nowrap'>
                                                {monthNames[date.getMonth()]} {date.getDate()} {date.getFullYear()}
                                            </TableCell>
                                            <TableCell>{item.action_taken}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    : <Stack spacing={1}>
                        {Array.from({ length: 3 }, (_, i) => i).map(i => (<Skeleton key={i} variant="rectangular" height={34} />))}
                    </Stack>
                }
            </Box>
        </Box>
    )
}

export default PatientLogs